var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.index !== null)?_c('li',{class:_vm.classname,style:(_vm.itemStyle),on:{"click":_vm.handleClick,"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_c('span',{staticClass:"effect-dropdown-item__label",style:(_vm.labelStyle)},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-990dae1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EffectDropdownItem.vue
// module id = 25
// module chunks = 0